import ProductDetailPage from '../components/products/ProductDetailPage';
import { getProductPageConfig } from '../data/products/productsRegistry';

const ContainerSleeves = () => <ProductDetailPage {...getProductPageConfig('containerSleeves')} />;

export default ContainerSleeves;
